import React, {useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { addStep } from "../redux/slices/step/stepSlice";
import IProduct from "../../models/product";
import { useParams } from "react-router-dom";


function RfEditorSidebar(props) {
  const { slug } = useParams();
  const dispatch = useDispatch();
  let datetime = (new Date().toLocaleDateString() + new Date().toLocaleTimeString())
  const getId = () => { return datetime}; //raises ID each time its called, its used for when nodes/panes are added
  const [name, setName] = useState("")
  // const product_id = props.props.id //gets ID from props
  const Products = useSelector((state) => state.product.data);
  console.log("filterdedarray",Products)

  const filteredArray = Products.find((product) => product.slug === slug);
  console.log("Products",filteredArray)

  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  const addNode = (event) => {
    const addedNode = {product: filteredArray.id, element: {
      id: `${getId()}`,
      data: {label: `${name}`},
      position: {x: 0, y: -5}, 
  }}
    dispatch(addStep((addedNode)))
};
  return (
    <aside>
      <div className="description">You can drag these nodes to the pane on the right.</div>
      <div className="dndnode input" onDragStart={(event) => onDragStart(event, 'input')} draggable>
        Start Node
      </div>
      <div className="dndnode" onDragStart={(event) => onDragStart(event, 'default')} draggable>
        Default Node
      </div>
      <div className="dndnode output" onDragStart={(event) => onDragStart(event, 'output')} draggable>
        End Node
      </div>
      <div>
      <input type="text"
          onChange={e => setName(e.target.value)}
          name="title"/>
          <button 
          type="button"
          onClick={addNode}
          >Add Node</button>
      </div>
    </aside>
  );
};

export default RfEditorSidebar